export default __webpack_public_path__ + "static/media/Musaned_logo.2720dcfe.svg";